<template>
  <div v-if="isVisible" id="om-container">
    <div id="om-content">
      <div id="om-header">
        <img id="om-bolt" src="../assets/graphic/icon-bolt-large.svg" alt="bolt" />
        <div id="om-title">Our Mission</div>
      </div>
      <div id="om-text">
        Inherit the Music is embarking on a campaign to inspire the next generation of musicians.
        Co-founded by Kings of Leon and the Living Legacy Foundation, Inherit the Music supports
        local organizations that pay forward the gifts that only music can provide. By providing
        resources and funding education programs at all age levels, this newly formed charitable
        organization aims to impact the aspiring musicians of today and the future.
      </div>
    </div>
    <v-parallax
        src="../assets/image/image-ourmission.png"
    >
      <v-row align="center" justify="center">
        <v-col justify="space-evenly" align="center" cols="12">
          <div id="om-kol-header">learn more about inherit the music</div>
          <div id="om-kol-website" @click="onClickVisitKol">visit inheritthemusic.org</div>
        </v-col>
      </v-row>
    </v-parallax>
  </div>
</template>
<script>
  export default {
    name: 'OurMission',
    props: {
      isVisible: {
        type: Boolean,
        default: false,
      }
    },
    methods: {
      onClickVisitKol () {
        window.open('https://inheritthemusic.org/', '_blank');
      }
    }
  }
</script>
<style lang="scss">
@import '~vuetify/src/styles/settings/_variables';
#om-container {
  background-color: #e4e4e4;
}
#om-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  padding: 5% 10%;
  height: 450px;
}
#om-header {
  display: flex;
  flex-direction: column;
  align-items: center;
}
#om-bolt {
  margin-bottom: 10px;
}
#om-title {
  font-size: 30px;
  font-family: SSNicksonFour, serif;
  text-align: center;
  color: black;
}
#om-text {
  font-size: 15px;
  font-family: Lato-Regular, sans-serif;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  color: black;
}
#om-kol-header {
  font-family: SSNicksonFour, serif;
  font-size: 30px;
  color: white;
  margin-bottom: 32px;
}
#om-kol-website {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #e1a732;
  font-family: Lato-Bold, sans-serif;
  font-size: 15px;
  text-transform: uppercase;
  width: 290px;
  height: 47px;
  border-radius: 24px;
  cursor: pointer;
  color: black;
  transition-property: opacity;
  transition-duration: 0.5s;
  &:hover {
    opacity: 0.8;
  }
}

@media #{map-get($display-breakpoints, 'lg-and-up')} {
  #om-content {
    height: 500px;
  }
}

@media #{map-get($display-breakpoints, 'xs-only')} {
  #om-container {
    padding-top: 6%;
  }

  #om-content {
    padding: 40px 20px;
    height: 348px;
  }

  #om-header, #om-text {
    margin-bottom: 20px;
  }

  #om-title {
    font-size: 17px;
  }

  #om-text {
    font-size: 12px;
  }

  #om-kol-header {
    font-size: 24px;
    line-height: normal;
    margin-bottom: 16px;
    width: 90%;
  }

  #om-kol-website {
    width: 247px;
  }
}
</style>